import { atom } from 'jotai';

export const initialCountMedals = {
  estado: false,
  cantidad: 0,
  rankingPublicado: 0,
};

export type CountMedalsData = {
  estado: boolean;
  cantidad: number;
  rankingPublicado: number;
};
export const medalsAtom = atom<CountMedalsData>(initialCountMedals);
